
import { MY_CONFIG } from "@/constants";
import { useLang } from "../../context/TranslationProvider";



const SkeletonLoader = () => {
  return (
    <div className="max-w-5xl mx-auto p-6 mt-8">
      <div className="animate-pulse space-y-4">
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
      </div>
    </div>
  );
};
export default SkeletonLoader;



export const MyLoader = () => {
  const { t } = useLang();

  return (
    <div className="flex flex-col justify-center items-center h-screen w-full 
                    bg-white dark:bg-gray-900 transition-colors duration-300">
      
      {/* Logo */}
      <img
        src={MY_CONFIG.logoUrl}
        alt="Logo"
        className="rounded-full w-24 h-24 mb-6 animate-pulse 
                   shadow-lg dark:shadow-gray-800"
      />

      {/* Spinner */}
      <div className="
          w-12 h-12 
          border-4 border-blue-600 border-t-transparent 
          dark:border-blue-400 dark:border-t-transparent
          rounded-full animate-spin
        ">
      </div>

      {/* Loading text */}
      <p className="mt-4 font-medium text-gray-700 dark:text-gray-300">
        {t("Loading...")}
      </p>
    </div>
  );
};